module.exports = __webpack_public_path__ + "static/media/aws.59a82d54.svg";